import { useTranslation } from 'next-i18next'

import { formatThousands } from '~/utils/helpers'

interface Props {
  tableNo: string
  score: number
  accuracy: number
}

export default function MultGameTableItem({ tableNo, score, accuracy }: Props): React.ReactElement {
  const { t } = useTranslation('statistics')

  return (
    <div className="flex justify-between items-center py-3">
      <div className="flex items-center justify-center h-6 w-6 rounded-full bg-orchid-dark">
        <span className="text-white font-semibold text-xs">{tableNo}</span>
      </div>
      <span className="text-sm font-medium">
        {t('multGame.score')}: {formatThousands(score)}
      </span>
      <span className="text-sm font-medium">
        {t('multGame.accuracy')}: {accuracy}%
      </span>
    </div>
  )
}
